const MEMORY_KEY = "sonicbox-terms-accounts-v1";
const DRAFT_KEY = "sonicbox-terms-draft-v1";
export const TERMS_DRAFT_TTL = 24 * 60 * 60 * 1000;
let volatileDraft = null;

export function consentScopeKey({ radioid, nameseo, scope }) {
  return scope?.key && scope?.referenceRadioid
    ? `scope:${scope.key}:${scope.referenceRadioid}`
    : `radio:${radioid || nameseo}`;
}
function readMemories() {
  try {
    const entries = JSON.parse(window.localStorage.getItem(MEMORY_KEY) || "[]");
    return Array.isArray(entries)
      ? entries.filter(
          (entry) => entry?.userid && typeof entry.scopeKey === "string",
        )
      : [];
  } catch (_) {
    return [];
  }
}
function writeMemories(entries) {
  try {
    window.localStorage.setItem(MEMORY_KEY, JSON.stringify(entries));
  } catch (_) {
    /* The server remains authoritative. */
  }
}
export function rememberConsent(context) {
  if (context.userid === undefined || context.userid === null) return;
  const scopeKey = consentScopeKey(context);
  const userid = String(context.userid);
  writeMemories([
    ...readMemories().filter(
      (item) => item.userid !== userid || item.scopeKey !== scopeKey,
    ),
    { userid, scopeKey },
  ]);
}
export function hasRememberedConsent(context) {
  return readMemories().some(
    (item) => item.scopeKey === consentScopeKey(context),
  );
}
export function forgetConsent(context) {
  writeMemories(
    readMemories().filter(
      (item) =>
        item.userid !== String(context.userid) ||
        item.scopeKey !== consentScopeKey(context),
    ),
  );
}
export function clearTermsDraft(expectedInteractionId = null) {
  if (expectedInteractionId) {
    let stored;
    try {
      stored = JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || "null");
    } catch (_) {
      stored = volatileDraft;
    }
    if (stored?.interactionId !== expectedInteractionId) return;
  }
  volatileDraft = null;
  try {
    window.sessionStorage.removeItem(DRAFT_KEY);
  } catch (_) {
    /* Storage may be disabled. */
  }
}
export function saveTermsDraft(draft) {
  const acceptedAt = Date.parse(draft.acceptedAt);
  const next = {
    ...draft,
    expiresAt: Math.min(
      acceptedAt + TERMS_DRAFT_TTL,
      draft.expiresAt || Infinity,
    ),
  };
  if (!Number.isFinite(next.expiresAt)) return null;
  try {
    window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify(next));
  } catch (_) {
    volatileDraft = next;
  }
  return next;
}
export function readTermsDraft(context, now = Date.now()) {
  let draft;
  try {
    draft = JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || "null");
  } catch (_) {
    draft = volatileDraft;
  }
  if (!draft || !Number.isFinite(draft.expiresAt) || draft.expiresAt <= now) {
    clearTermsDraft();
    return null;
  }
  if (draft.intentId !== context.intentId || draft.nameseo !== context.nameseo)
    return null;
  return draft;
}
